import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

export const Title = styled.div`
    ${setFontVariant("body2", colorsPalettes.carbon[400])};
    margin-right: 8px;
`;

export const Container = styled(FlexRow)`
    align-items: center;
`;
